import installMobilePopup from './component'

export default installMobilePopup
